import { render, staticRenderFns } from "./ListProjectItem.vue?vue&type=template&id=2d6638f0&scoped=true&lang=html&"
import script from "./ListProjectItem.vue?vue&type=script&lang=js&"
export * from "./ListProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./ListProjectItem.vue?vue&type=style&index=0&id=2d6638f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6638f0",
  null
  
)

export default component.exports